// The red wax "1st" seal of the Stamp of Precedence (P-11): drawn in the HUD on the Stamp's
// holder, and pressed onto a form in the title-screen key art.
/** Wobbly wax outline, computed once: a disc with soft drips at its edge. */
const WAX_PATH = (() => {
  const pts: string[] = [];
  const n = 36;
  for (let i = 0; i < n; i++) {
    const a = (i / n) * Math.PI * 2;
    const r = 46 + 2.2 * Math.sin(i * 2.7) + 1.6 * Math.cos(i * 5.3) + (i % 9 === 4 ? 3 : 0);
    pts.push(`${(50 + r * Math.cos(a)).toFixed(1)},${(50 + r * Math.sin(a)).toFixed(1)}`);
  }
  return `M${pts.join('L')}Z`;
})();

export function WaxSealArt({ size, ghost = false }: { size: number; ghost?: boolean }) {
  const id = ghost ? 'wax-ghost' : 'wax';
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden>
      <defs>
        <radialGradient id={`${id}-fill`} cx="38%" cy="32%" r="75%">
          <stop offset="0" stopColor={ghost ? '#3a3440' : '#e0414d'} />
          <stop offset="0.55" stopColor={ghost ? '#26222c' : '#a51f2d'} />
          <stop offset="1" stopColor={ghost ? '#1a171f' : '#6a0f18'} />
        </radialGradient>
      </defs>
      <path d={WAX_PATH} fill={`url(#${id}-fill)`} stroke={ghost ? 'rgba(201,164,90,0.25)' : '#4a0910'} strokeWidth="1.5" strokeDasharray={ghost ? '4 4' : undefined} />
      <circle cx="50" cy="50" r="31" fill="none" stroke={ghost ? 'rgba(201,164,90,0.18)' : 'rgba(60,4,10,0.55)'} strokeWidth="3" />
      <circle cx="50" cy="50" r="31" fill="none" stroke={ghost ? 'none' : 'rgba(255,170,170,0.25)'} strokeWidth="1.2" transform="translate(0.8 1)" />
      {!ghost && <path d="M24 34 A30 30 0 0 1 44 20" fill="none" stroke="rgba(255,210,210,0.45)" strokeWidth="3.5" strokeLinecap="round" />}
      {/* "1st" with a big 1 so it reads even at rival-card size: a dark impression under light wax. */}
      <text x="50" y="66" textAnchor="middle" fontFamily="Cinzel, serif" fontWeight="700" fill={ghost ? 'rgba(201,164,90,0.35)' : '#3a0409'} transform={ghost ? undefined : 'translate(1.2 1.8)'}>
        <tspan fontSize="42">1</tspan>
        <tspan fontSize="19" dy="-17">st</tspan>
      </text>
      {!ghost && (
        <text x="50" y="66" textAnchor="middle" fontFamily="Cinzel, serif" fontWeight="700" fill="#ffe2c6">
          <tspan fontSize="42">1</tspan>
          <tspan fontSize="19" dy="-17">st</tspan>
        </text>
      )}
    </svg>
  );
}
